/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */

/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable array-callback-return */
import { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { ToastContainer, toast } from 'react-toastify'

import updateUserPermissionsService from '../../Services/Mutations/updateUserPermissionsService'
function PermissionsPopUp(props) {
  const {
    show,
    setShow,
    userRolesandPermissionsArray,
    rolesArray,
    PermissionsList,
    sendRowData,
    selectedUserPermissions,
  } = props
  const [
    RoleNamesFromSelectedPermissiosnState,
    setRoleNamesFromSelectedPermissiosnState,
  ] = useState()
  const toastStyle = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  const [permissionSelected, setpermissionSelected] = useState(true)
  const [initialroles, setInitialRoleNames] = useState()
  const [preSelectedNames, setpreSelectedNames] = useState([])

  const [PreviousSelectedRole, setPreviousSelectedRole] = useState()
  const [userPermissions, setUserPermissions] = useState()
  const [selectedPermissions, setSelectedPermissions] = useState([])
  const [selectedPermissionsArrValues, setSelectedPermissionsArrValues] = useState([])
  // const [SpliceStateArray, setSpliceStateArray] = useState([])
  const [initialNonModefiedValues, setInitialNonModefiedValues] = useState([])
  // const [removedRolesval, setRemovedRoles] = useState([])
  const [selectedPermissionsWithParent, setSelectedPermissionWithParent] = useState([])
  // let checkBoxSelected
  const handleClose = async () => {
    setpermissionSelected(true)
    setUserPermissions(preSelectedNames)
    setSelectedPermissions([selectedPermissions])
    setShow(false)
  }

  // const roleNameArray = [...roleNamesData]
  const checkBoxHandle = async (permissionParentData, permission) => {
    setpermissionSelected(false)
    delete permission.__typename

    const userExistingPermissions = userPermissions && [...userPermissions]

    const itemIndex =
      userExistingPermissions && userExistingPermissions.findIndex(item => item === permission.name)

    // if (userPermissions.length === 0) {
    // userExistingPermissions.push(permission.name)
    if (itemIndex > -1) {
      userExistingPermissions.splice(itemIndex, 1)
    } else {
      userExistingPermissions.push(permission.name)
    }

    setUserPermissions(userExistingPermissions)
    // storing all the previous selected permissions into a variable
    const previousSelectedPermissions = selectedPermissions && [...selectedPermissions]

    setPreviousSelectedRole(previousSelectedPermissions)
    // storing all the previous selected permissions with parents into a variable

    const temporaryPermissionsWithParent = selectedPermissionsWithParent && [
      ...selectedPermissionsWithParent,
    ]

    // checking if the selected parent permission is already exist in the array
    const findParentIndex =
      temporaryPermissionsWithParent &&
      temporaryPermissionsWithParent.findIndex(
        item => item.roleName === permissionParentData.roleName,
      )
    // if selected parent permission already exists then push permission into same parent
    if (findParentIndex > -1) {
      // checking if the selected permission is already exist in the parent permissions array
      const findPermissionIndex =
        temporaryPermissionsWithParent &&
        temporaryPermissionsWithParent[findParentIndex].permissions.findIndex(
          item => item.name === permission.name,
        )
      // if selected permission already exists in the parent permissions array then splice it from the array
      if (findPermissionIndex > -1) {
        temporaryPermissionsWithParent &&
          temporaryPermissionsWithParent[findParentIndex].permissions.splice(findPermissionIndex, 1)
      } else {
        // if selected permission does not exist in the parent permissions array then push it into the array
        delete permission.__typename

        temporaryPermissionsWithParent[findParentIndex].permissions.push(permission)
      }
    } else {
      // if selected permission parent does not exist then create new parent object and push permission into it
      delete permission.__typename
      const newParent = {
        roleName: permissionParentData.roleName,
        permissions: [permission],
      }

      temporaryPermissionsWithParent.push(newParent)
    }

    const removeTypenameAndReplaceActive = obj => {
      if (!obj || typeof obj !== 'object') {
        return obj
      }

      if (Array.isArray(obj)) {
        return obj.map(item => removeTypenameAndReplaceActive(item))
      }

      const { __typename, active, ...rest } = obj
      if (active !== undefined) {
        rest.selected = active
      }

      Object.keys(rest).forEach(key => {
        rest[key] = removeTypenameAndReplaceActive(rest[key])
      })

      return rest
    }

    const updatedArray = temporaryPermissionsWithParent.map(item =>
      removeTypenameAndReplaceActive(item),
    )

    setSelectedPermissionWithParent(updatedArray && updatedArray)
  }

  const handleSaveChange = async () => {
    const removedRolesval =
      selectedPermissionsWithParent &&
      selectedPermissionsWithParent.filter(item => item.permissions.length === 0)

    let removedRoleNameList = removedRolesval && removedRolesval.map(item => item.roleName)
    removedRoleNameList =
      removedRoleNameList && removedRoleNameList.filter(item => initialroles.includes(item))

    // getting all the roles names from the selected permissions into an array
    const roleNames =
      selectedPermissionsWithParent && selectedPermissionsWithParent.map(item => item.roleName)

    const finalRoleNames =
      roleNames && roleNames.filter(item => !removedRoleNameList.includes(item))
    const finalSelectedPermissionsWithParent =
      selectedPermissionsWithParent &&
      selectedPermissionsWithParent.filter(item => item.permissions.length !== 0)

    const removeTypenameField = finalSelectedPermissionsWithParent => {
      if (
        !finalSelectedPermissionsWithParent ||
        typeof finalSelectedPermissionsWithParent !== 'object'
      ) {
        return finalSelectedPermissionsWithParent
      }

      if (Array.isArray(finalSelectedPermissionsWithParent)) {
        return (
          finalSelectedPermissionsWithParent &&
          finalSelectedPermissionsWithParent.map(item => removeTypenameField(item))
        )
      }

      const { __typename, ...rest } = finalSelectedPermissionsWithParent
      Object.keys(rest).forEach(key => {
        rest[key] = removeTypenameField(rest[key])
      })

      return rest
    }

    const updatedArray = removeTypenameField(finalSelectedPermissionsWithParent)

    // const remove = PreviousSelectedRole.filter(item => item.name)

    const input = {
      PK: sendRowData.PK,
      SK: sendRowData.SK,
      roles: finalRoleNames,
      removedRoles: removedRoleNameList,
      userRolesAndPermissions: updatedArray,
    }

    const updatePermission = await updateUserPermissionsService(input)

    if (
      updatePermission.data.updateUserRolesAndPermissions &&
      updatePermission.data.updateUserRolesAndPermissions.statusCode === 'A216'
    ) {
      toast.success(updatePermission.data.updateUserRolesAndPermissions.statusMessage, toastStyle)
      props.reloadPermissions()
    } else {
      toast.error('failed to update', toastStyle)
    }

    // setRemovedRoles([])
    setShow(false)
  }

  useEffect(() => {
    const setObjectSToArray = async () => {
      const array = []
      const initialRoleNames = []

      setSelectedPermissionWithParent(
        props.selectedUserPermissions && props.selectedUserPermissions,
      )

      selectedUserPermissions &&
        selectedUserPermissions.map(item => {
          item.permissions.map(value => {
            array.push(value)
          })
        })

      selectedUserPermissions &&
        selectedUserPermissions.map(item => {
          initialRoleNames.push(item.roleName)
        })

      setInitialRoleNames(initialRoleNames)

      const rolevalues = array && array.map(item => item.name)

      setSelectedPermissionsArrValues(array)
      setSelectedPermissions(array)
      setUserPermissions(rolevalues)
      setpreSelectedNames(rolevalues)
      setInitialNonModefiedValues(array)
    }

    setObjectSToArray()
  }, [])

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>User Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflowY: 'scroll', height: '60vh' }}>
          {PermissionsList &&
            PermissionsList.map(objVal => (
              <>
                <lable>
                  <b>{objVal.roleName}</b>
                </lable>

                {objVal.permissions.map((value, index) => {
                  let checkIsItemSelected = false
                  const selectedItemIndex =
                    userPermissions && userPermissions.findIndex(item => item === value.name)
                  if (selectedItemIndex > -1) {
                    checkIsItemSelected = true
                  }

                  return (
                    <div key={index}>
                      <input
                        onChange={() => checkBoxHandle(objVal, value)}
                        checked={checkIsItemSelected}
                        key={index}
                        type='checkbox'
                      />
                      <span>{value.name}</span>
                    </div>
                  )
                })}
              </>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button disabled={permissionSelected} variant='primary' onClick={handleSaveChange}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default PermissionsPopUp
